import * as Response from 'src/api/interfaces/responses/tags'
import { IProfileTag } from 'src/interfaces/tags'

export const $profileTags = (json: Response.IProfileTag[]): IProfileTag[] => {
  return json.map((tag) => ({
    name: tag.tag.name,
    profileTagId: tag.identifier,
    tagId: tag.tag.identifier
  }))
}
